$(document).ready(function() {

  // filter and sort facilities
  if ($('.wf-mixer').length) {
    var mixer = mixitup('.wf-mixer', {
      animation: {
        effects: 'fade scale',
        duration: 500,
        easing: 'ease-in-out'
      },
      controls: {
        enable: false
      },
      debug: {
        enable: false
      },
      load: {
        filter: 'all'
      },
      multifilter: {
        enable: false
      },
      selectors: {
        target: '.chirp-block-facility-card'
      }
    });

    $('.wf-mixer-controls-states-group a').on('click', function(e) {
      e.preventDefault();
      var value = $(this).attr('data-filter');
      $('select[name="filter-locations"]').val(value);
      $('.wf-mixer-controls-states-group a').removeClass('active');
      $(this).addClass('active');
      mixer.filter(value);
    });

    $('select[name="filter-locations"]').on('change', function() {
      var value = $(this).val();
      $('.wf-mixer-controls-states-group a').removeClass('active');
      $('.wf-mixer-controls-states-group a[data-filter="' + value + '"]').addClass('active')

      mixer.filter(value);
    });

  }

});
